import React from 'react';
import { Input, Button, PaperClip, Select, CheckboxTable, DatePicker } from 'components';
import { CategoryService, AuthService } from 'services';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import { Globals, Constants, Socket, SocketEvents } from 'utils';
import { WhiteImage } from 'assets/img';
import { LocationIcon, TimeIcon } from 'assets/icons';
import moment from 'moment';

interface Props {
	onClose?: any;
	item?: any;
}

class ModalCreate extends React.Component<Props> {

	state = {
		form: {
			name: '',
	        image: '',
		},
		cities: []
	}

	componentDidMount() {
		if (this.props.item) {
			this.setState({
				form: {
					...this.state.form,
					name: this.props.item?.name,
			        image: this.props.item?.image,
				}
			});
		}
	}

	submit = async (e: any) => {
		e.preventDefault();

		if(this.state.form.name.trim() === '') {
			Globals.showError("El nombre es obligatorio");
			return;
		}
		if(this.state.form.image === '') {
			Globals.showError("La imagen es obligatoria");
			return;
		}

		if (this.props.item != null) {
			await CategoryService.admin.update({
				id: this.props.item?.id,
				...this.state.form,
				hasFile: true,
				// @ts-ignore,
				img: this.state.form.image?.value || '',
			});
			Globals.showSuccess("Se ha modificado la categoría correctamente");
			Socket.emit(SocketEvents.UPDATE_USER,{
				user_id: this.props.item?.id
			});
			this.props.onClose();
		}
		else {
			await CategoryService.admin.create({
				...this.state.form,
				hasFile: true,
				// @ts-ignore,
				img: this.state.form.image?.value || '',
			});
			Globals.showSuccess("Se ha creado la categoría correctamente");
			this.props.onClose();
		}
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}
	
	render() {
		return (
			<div id="modal-create-clinic">
				<form className="row" onSubmit={ this.submit }>
					<div className="col-12">
						<div className="container-image">
							<PaperClip
								className="paperclip-image"
								value={ this.state.form.image }
								onChange={ (e: any) => {
									this.setState({
										form: {
											...this.state.form,
											image: e.target
										}
									})
								} }>
								{/*
								// @ts-ignore */}
								<img className={ `selected-image ${ (this.state.form.image || this.props.item?.image) ? '' : 'inactive' }` } src={ this.state.form.image?.dataURL || (this.props.item?.image ? (Constants.BASE_STORAGE + this.props.item?.image) : WhiteImage) } />
							</PaperClip>
							<p className="photo-title">Foto o logo</p>
						</div>
					</div>
					<div className="col-md-6">
						<Input
							color="white"
							value={ this.state.form.name }
							name="name" 
							placeholder="Nombre"
							label="Nombre"
							onChange={ this.change } />
					</div>
					<div className="col-12">
						<div className="row row-buttons">
							<div className="col-md-6 text-center">
								<Button type="button" onClick={ () => this.props.onClose() }>
									Cerrar
								</Button>
							</div>
							<div className="col-md-6 text-center">
								<Button type="submit">
									Guardar
								</Button>
							</div>
						</div>
					</div>
				</form>
			</div>
		)
	}
}

export default ModalCreate;